import React from "react";
import {ColumnLayout, Input, Select} from "@amzn/awsui-components-react";

export class JoinCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {...this.props.data};
  }

  handleChange = (change, e) => {
    const newState = {};
    newState[change] = e.detail.selectedId;
    this.setState(newState, () => {
      this.props.onChange({...this.state});
    });
  }

  render() {
    const selection0 = this.props.columns.filter(x => x[1] === this.props.data.column0);
    const selection1 = this.props.columns.filter(x => x[1] === this.props.data.column1);
    let outputName = "";
    if (selection0.length > 0 && selection1.length > 0) {
      outputName = "New source is " + `${selection0[0][1].split(".")[0]}_X_${selection1[0][1].split(".")[0]}`;
    }
    return <ColumnLayout columns={3}>
      <div data-awsui-column-layout-root="true">
        <div>
          Column 1:
          <Select options={this.props.columns.map((x) => {
            return {label: x[0], id: x[1]};
          })}
                  selectedOption={{
                    label: selection0.length > 0? selection0[0][0]: "",
                    id: selection0.length > 0? selection0[0][0]: "",
                  }}
                  onChange={(e) => this.handleChange('column0', e)}
                  selectedLabel="Selected"
                  filteringType={"auto"}
                  disabled={this.props.disabled}/>
        </div>
        <div>
          Column 2:
          <Select options={this.props.columns.map((x) => {
            return {label: x[0], id: x[1]};
          })}
                  selectedOption={{
                    label: selection1.length > 0? selection1[0][0]: "",
                    id: selection1.length > 0? selection1[0][0]: "",
                  }}
                  onChange={(e) => this.handleChange('column1', e)}
                  selectedLabel="Selected"
                  filteringType={"auto"}
                  disabled={this.props.disabled}/>
        </div>
        <div>
          {outputName}
        </div>
      </div>
    </ColumnLayout>;
  }
}
